import React, { useRef, useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFade, Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
const BullDozerNewHeroCarousel = ({phoneData}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const swiperRef = useRef(null);
  const mobileSwiperRef = useRef(null);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slides = [
    {
      id: 1,
      backgroundImage: '/images/bulldozer/bulldozer_slide_1.webp',
      mobileImage: '/images/bulldozer/bulldozer_mobile_1.webp',
      title: 'Wide Range of Reliable Dozers',
      subtitle: 'Shortlisted Dozers that deliver powerful results.',
      badge: null
    },
    {
      id: 2,
      backgroundImage: '/images/bulldozer/bulldozer_slide_2.webp',
      mobileImage: '/images/bulldozer/bulldozer_mobile_2.webp',
      title: 'HW 16D - Bulldozers That Mean Business',
      subtitle: 'Engineered for strength, speed, and results.',
      badge: null
    },
    {
      id: 3,
      backgroundImage: '/images/bulldozer/bulldozer_slide_3.webp',
      mobileImage: '/images/bulldozer/bulldozer_mobile_3.webp',
      title: 'HW 22D Bulldozers Your Trustworthy Groundwork Partner.',
      subtitle: 'Engineered for strength, speed, and results.',
      badge: null
    },
    {
        id:4,
        backgroundImage: '/images/bulldozer/bulldozer_slide_4.webp',
        mobileImage:'/images/bulldozer/bulldozer_mobile_4.webp',
        title:'HW32D Dozer. Pure Power.',
        subtitle:'Golden Sparrow handpicks machines that last',
        badge:'New!'
    }
  ];

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  const handleMobileSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  // Mobile Slider View
  if (isMobile) {
    return (
      <>
        <div className="mobile-slider-container">
          <Swiper
            ref={mobileSwiperRef}
            modules={[Autoplay, Pagination]}
            speed={600}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              el: '.mobile-custom-pagination',
              clickable: true,
              bulletClass: 'mobile-custom-bullet',
              bulletActiveClass: 'mobile-custom-bullet-active'
            }}
            onSlideChange={handleMobileSlideChange}
            className="mobile-hero-swiper"
            spaceBetween={0}
            slidesPerView={1}
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={slide.id}>
                <div className="mobile-card">
                  <div className="mobile-image-wrapper">
                    <img 
                      src={slide.mobileImage || slide.backgroundImage} 
                      alt={slide.title}
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                  </div>
                  <div className="mobile-content-wrapper">
                    <div className="mobile-content">
                      {slide.badge && <div className="mobile-badge">{slide.badge}</div>}
                      <h2 className="mobile-title">{slide.title}</h2>
                      <p className="mobile-subtitle">{slide.subtitle}</p>
                      {slide.additionalInfo && (
                        <p className="mobile-additional-info">{slide.additionalInfo}</p>
                      )}
                      {phoneData?.acf?.phone_bulldozers && (
                      <button
                        onClick={() => { window.location.href = `tel:+${phoneData?.acf?.phone_bulldozers}` }}
                        className="mobile-cta-button"
                        aria-label="Call to get a quote"
                      >
                        <span className="mobile-button-content">
                          <img src='/images/icons/phone_mob.png' alt="" />
                        </span>
                        <span className="mobile-button-content">Get a Quote</span>
                      </button>

                      )}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* <div className="mobile-custom-pagination"></div> */}
        </div>

        <style jsx>{`
          .mobile-slider-container {
            width: 100%;
            background: #FFFFFFE5;
            position: relative;
            //padding-bottom: 50px;
          }

          .mobile-hero-swiper {
            width: 100%;
            height: 100%;
          }

          .mobile-card {
            background: #fff;
            overflow: visible;
            position: relative;
            min-height: 580px;
            height: 100%;
          }

          .mobile-image-wrapper {
            width: 100%;
            height: 100%;
            overflow: hidden;
            background: #FFFFFFE5;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }

          .mobile-image-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .mobile-content-wrapper {
            position: absolute;
            top: min(240px, 35vh);
            left: 18px;
            right: 18px;
            z-index: 10;
          }
            
          .mobile-content {
            padding: 18px;
            border-radius: 12px;
            border-left: 4px solid #FFD200;
            background-color: #FFFFFFE5;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            width: 100%;
          }

          .mobile-badge {
            border: 3px solid transparent;
            background-image: linear-gradient(#fff, #fff), linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
            background-origin: border-box;
            background-clip: padding-box, border-box;
            border-radius: 8px;
            color: #000;
            font-size: 14px;
            font-weight: 600;
            font-style: italic;
            padding: 4px 16px;
            display: inline-block;
            margin-bottom: 12px;
          }

          .mobile-title {
            font-size: 20px;
            font-weight: 600;
            color: #000;
            line-height: 1.3;
            margin: 0 0 10px 0;
          }

          .mobile-subtitle {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin: 0 0 8px 0;
            line-height: 1.4;
          }

          .mobile-additional-info {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
            margin: 0 0 20px 0;
          }

          .mobile-cta-button {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 100%;
            padding: 14px 24px;
            border: 2px solid transparent;
            background-image: linear-gradient(#000, #000), conic-gradient(from 167.85deg at 75.81% -16.57%, #EEBC70 -21.72deg, #E3A455 26.25deg, #FFEBC4 156.58deg, #D0A068 261.59deg, #EEBC70 338.28deg, #E3A455 386.25deg);
            background-origin: border-box;
            background-clip: padding-box, border-box;
            font-size: 18px;
            font-weight: 600;
            border-radius: 6px;
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .mobile-cta-button:active {
            transform: scale(0.97);
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
          }

          .mobile-button-content {
          background: linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
          //background: conic-gradient(from 167.85deg at 75.81% -16.57%, #EEBC70 -21.72deg, #E3A455 26.25deg, #FFEBC4 156.58deg, #D0A068 261.59deg, #EEBC70 338.28deg, #E3A455 386.25deg);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
            display: flex;
            align-items: center;
          }

          .mobile-button-content img {
            width: 20px;
            height: 20px;
            filter: brightness(0) saturate(100%) invert(73%) sepia(44%) saturate(2619%) hue-rotate(346deg) brightness(102%) contrast(97%);
          }

          /* Mobile Pagination */
          .mobile-custom-pagination {
            position: absolute;
            bottom: 15px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 10px;
            z-index: 100;
          }

          .mobile-custom-pagination :global(.mobile-custom-bullet) {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.3);
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .mobile-custom-pagination :global(.mobile-custom-bullet::before) {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(45deg, #FFD200, #F7971E);
            border-radius: 50%;
            transform: scale(0);
            transition: transform 0.3s ease;
          }

          .mobile-custom-pagination :global(.mobile-custom-bullet-active) {
            background: transparent;
            transform: scale(1.3);
          }

          .mobile-custom-pagination :global(.mobile-custom-bullet-active::before) {
            transform: scale(1);
          }

          /* Responsive adjustments for very small devices */
          @media (max-width: 375px) {
            .mobile-card {
              min-height: 580px;
            }

            .mobile-content-wrapper {
              top: min(200px, 30vh);
              left: 12px;
              right: 12px;
            }

            .mobile-content {
              padding: 16px;
            }

            .mobile-title {
              font-size: 18px;
            }

            .mobile-subtitle {
              font-size: 15px;
            }

            .mobile-additional-info {
              font-size: 13px;
              margin-bottom: 16px;
            }

            .mobile-cta-button {
              padding: 12px 20px;
              font-size: 16px;
            }
          }

          /* Larger mobile devices */
          @media (min-width: 376px) and (max-width: 639px) {
            .mobile-content-wrapper {
              top: min(320px, 42vh);
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .mobile-cta-button,
            .mobile-custom-pagination :global(.mobile-custom-bullet) {
              transition: none !important;
            }
          }
        `}</style>
      </>
    );
  }

  // Desktop/Tablet Carousel View (unchanged)
  return (
    <>
      <div className="carousel-container">
        <Swiper
          ref={swiperRef}
          modules={[EffectFade, Autoplay, Navigation, Pagination]}
          effect="fade"
          fadeEffect={{
            crossFade: true
          }}
          speed={800}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          navigation={{
            nextEl: '.custom-next',
            prevEl: '.custom-prev',
          }}
          pagination={{
            el: '.custom-pagination',
            clickable: true,
            bulletClass: 'custom-bullet',
            bulletActiveClass: 'custom-bullet-active'
          }}
          onSlideChange={handleSlideChange}
          className="hero-swiper"
          spaceBetween={0}
          slidesPerView={1}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={slide.id}>
              <div className={`carousel-slide ${activeIndex === index ? 'active' : ''}`}>
                <div
                  className={`slide-bg`}
                  style={{backgroundImage: `url(${slide.backgroundImage})`}}
                ></div>
                <div className="slide-content">
                  <div className="text-content">
                    {slide.badge && <div className="badge">{slide.badge}</div>}
                    <div className="title">
                      {slide.titleHighlight ? (
                        slide.title.split(' ').map((word, i) => (
                          <span key={i} className={slide.titleHighlight.position === i ? 'highlight' : ''}>
                            {word}{' '}
                          </span>
                        ))
                      ) : (
                        slide.title
                      )}
                    </div>
                    <div className="subtitle">{slide.subtitle}</div>
                    {phoneData?.acf?.phone_bulldozers && (
                    <button
                      onClick={() => { window.location.href = `tel:+${phoneData?.acf?.phone_bulldozers}` }}
                      className="cta-button"
                      aria-label="Call to get a quote now"
                    >
                      <span className="button-content"><img src='/images/phone_icon.png' alt="" /></span>
                      <span className="button-content">Get Quote NOW</span>
                    </button>
                    )}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="nav-arrow custom-prev" role="button" aria-label="Previous slide"></div>
        <div className="nav-arrow custom-next" role="button" aria-label="Next slide"></div>
        <div className="custom-pagination" role="tablist" aria-label="Slide pagination"></div>
      </div>
      <style jsx>{`
        .carousel-container {
          position: relative;
          width: 100%;
          height: clamp(420px, 60vh, 520px);
          overflow: hidden;
          background: #fff;
        }

        .hero-swiper {
          width: 100%;
          height: 100%;
        }

        .hero-swiper .swiper-slide {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .carousel-slide {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .slide-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }

        .slide-content {
          position: relative;
          height: 100%;
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 clamp(20px, 4vw, 32px);
          display: flex;
          align-items: center;
          justify-content: flex-start;
          overflow: hidden;
        }

        .text-content {
          position: relative;
          max-width: clamp(450px, 55vw, 619px);
          width: 100%;
          padding: clamp(20px, 3vw, 30px);
          z-index: 5;
          border-left: 4px solid #FFD200;
          background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.92) 16.83%);
          border-radius: 8px;
        }

        .title {
          font-size: clamp(28px, 4vw, 44px);
          font-weight: 600;
          color: #000;
          line-height: 1.15;
          letter-spacing: -0.5px;
          margin-bottom: clamp(6px, 1vw, 8px);
          opacity: 0;
          transform: translateX(-80px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          will-change: transform, opacity;
        }

        .title .highlight {
          font-weight: 400;
          position: relative;
        }

        .active .title {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.3s;
        }

        .subtitle {
          font-size: clamp(16px, 2.5vw, 24px);
          font-weight: 500;
          color: #333;
          line-height: 1.4;
          letter-spacing: -0.2px;
          margin-bottom: clamp(20px, 3vw, 32px);
          opacity: 0;
          transform: translateX(-60px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          will-change: transform, opacity;
        }

        .active .subtitle {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.5s;
        }

        .cta-button {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          gap: clamp(8px, 1.5vw, 10px);
          padding: clamp(12px, 2vw, 14px) clamp(20px, 3vw, 28px);
          border: 2px solid transparent;
          background-image: linear-gradient(#000, #000), conic-gradient(from 167.85deg at 75.81% -16.57%, #EEBC70 -21.72deg, #E3A455 26.25deg, #FFEBC4 156.58deg, #D0A068 261.59deg, #EEBC70 338.28deg, #E3A455 386.25deg);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          font-size: clamp(16px, 2.2vw, 22px);
          line-height: 1.2;
          font-weight: 600;
          border-radius: 8px;
          opacity: 0;
          transform: translateX(-40px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          cursor: pointer;
          will-change: transform, opacity;
          width: 100%;
          min-width: clamp(220px, 30vw, 250px);
          max-width: clamp(320px, 40vw, 417px);
        }

        .cta-button:hover {
          transform: translateY(-2px) scale(1.02);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .button-content {
          background: conic-gradient(from 167.85deg at 75.81% -16.57%, #EEBC70 -21.72deg, #E3A455 26.25deg, #FFEBC4 156.58deg, #D0A068 261.59deg, #EEBC70 338.28deg, #E3A455 386.25deg);
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
          display: flex;
          align-items: center;
        }

        .button-content img {
          width: clamp(18px, 2vw, 22px);
          height: clamp(18px, 2vw, 22px);
          filter: brightness(0) saturate(100%) invert(73%) sepia(44%) saturate(2619%) hue-rotate(346deg) brightness(102%) contrast(97%);
        }

        .active .cta-button {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.7s;
        }

        .badge {
          border: 4px solid transparent;
          background-image: linear-gradient(#fff, #fff), linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border-radius: 12px;
          color: #000;
          font-size: clamp(14px, 1.8vw, 20px);
          font-weight: 600;
          font-style: italic;
          padding: clamp(3px, 0.5vw, 4px) clamp(20px, 3vw, 32px);
          display: inline-block;
          margin-bottom: clamp(12px, 2vw, 16px);
          opacity: 0;
          transform: translateX(-50px);
          transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          will-change: transform, opacity;
        }

        .active .badge {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.2s;
        }

        .nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: clamp(40px, 5vw, 55px);
          height: clamp(40px, 5vw, 55px);
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          opacity: 0.8;
        }

        .nav-arrow:hover {
          background: rgba(255, 255, 255, 0.25);
          border-color: rgba(255, 255, 255, 0.5);
          transform: translateY(-50%) scale(1.1);
          opacity: 1;
        }

        .nav-arrow.custom-prev {
          left: clamp(15px, 2.5vw, 25px);
        }

        .nav-arrow.custom-next {
          right: clamp(15px, 2.5vw, 25px);
        }

        .nav-arrow::before {
          content: '';
          width: clamp(9px, 1.3vw, 14px);
          height: clamp(9px, 1.3vw, 14px);
          border-top: 3px solid rgba(255, 255, 255, 0.9);
          border-right: 3px solid rgba(255, 255, 255, 0.9);
          transition: all 0.3s ease;
        }

        .nav-arrow.custom-prev::before {
          transform: rotate(-135deg);
          margin-left: 3px;
        }

        .nav-arrow.custom-next::before {
          transform: rotate(45deg);
          margin-right: 3px;
        }

        .custom-pagination {
          position: absolute;
          bottom: clamp(20px, 3.5vw, 35px);
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: clamp(8px, 1.5vw, 15px);
          z-index: 100;
        }

        .custom-pagination :global(.custom-bullet) {
          width: clamp(9px, 1.3vw, 14px);
          height: clamp(9px, 1.3vw, 14px);
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
          overflow: hidden;
        }

        .custom-pagination :global(.custom-bullet::before) {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, #FFD200, #F7971E);
          border-radius: 50%;
          transform: scale(0);
          transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .custom-pagination :global(.custom-bullet-active) {
          background: transparent;
          transform: scale(1.2);
        }

        .custom-pagination :global(.custom-bullet-active::before) {
          transform: scale(1);
        }

        .custom-pagination :global(.custom-bullet:hover) {
          background: rgba(255, 255, 255, 0.7);
          transform: scale(1.1);
        }

        @media (max-width: 1024px) {
          .carousel-container {
            height: clamp(400px, 55vh, 480px);
          }

          .slide-content {
            padding: 0 clamp(24px, 3vw, 40px);
          }

          .text-content {
            max-width: clamp(400px, 65vw, 550px);
            padding: clamp(18px, 2.5vw, 26px);
          }
        }

        @media (max-width: 768px) {
          .carousel-container {
            height: clamp(380px, 50vh, 440px);
          }

          .text-content {
            max-width: 85%;
            padding: clamp(16px, 2.5vw, 22px);
          }

          .title {
            font-size: clamp(24px, 4.5vw, 32px);
            margin-bottom: 6px;
          }

          .subtitle {
            font-size: clamp(15px, 2.8vw, 20px);
            margin-bottom: clamp(16px, 2.5vw, 24px);
          }

          .cta-button {
            min-width: clamp(200px, 35vw, 240px);
            //max-width: 100%;
            padding: clamp(11px, 2vw, 13px) clamp(18px, 2.5vw, 24px);
            font-size: clamp(15px, 2.3vw, 18px);
          }

          .badge {
            font-size: clamp(13px, 2vw, 16px);
            padding: 3px clamp(16px, 2.5vw, 24px);
            margin-bottom: clamp(10px, 1.5vw, 14px);
          }

          .nav-arrow {
            width: clamp(38px, 5.5vw, 48px);
            height: clamp(38px, 5.5vw, 48px);
          }

          .nav-arrow.custom-prev {
            left: clamp(12px, 2vw, 20px);
          }

          .nav-arrow.custom-next {
            right: clamp(12px, 2vw, 20px);
          }
        }

        @media (min-width: 640px) and (max-width: 767px) {
          .carousel-container {
            height: clamp(360px, 48vh, 420px);
          }

          .text-content {
            max-width: 90%;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .carousel-slide,
          .title,
          .subtitle,
          .cta-button,
          .badge,
          .nav-arrow,
          .custom-bullet {
            transition: none !important;
            animation: none !important;
          }

          .active .title,
          .active .subtitle,
          .active .cta-button,
          .active .badge {
            opacity: 1;
            transform: none !important;
          }

          .cta-button:hover,
          .nav-arrow:hover {
            transform: none !important;
          }
        }

        @media (prefers-contrast: high) {
          .nav-arrow {
            border: 3px solid rgba(255, 255, 255, 0.8);
          }

          .badge {
            border-width: 3px;
          }
        }

        @media (max-width: 639px) {
          .carousel-container {
            display: none;
          }
        }
      `}</style>
    </>
  )
}

export default BullDozerNewHeroCarousel